export default __webpack_public_path__ + "static/media/dancer.042513cd.png";